export const getSelectStyles = ( filterWidth, filterHeight, vp ) => {

    return {
        container: ( styles ) => {

            return {
                ...styles,
                margin: '0',
            };

        },
        groupHeading: ( styles ) => {

            return {
                ...styles,
                color: '#556074',
                fontFamily: 'Graphik-Medium',
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '18px',
                margin: '0 16px 2px 16px',
                padding: '0 0 4px 0',
                borderBottom: '1px solid #C9D5DE',
                textTransform: 'normal',
            };

        },
        option: ( provided, state ) => ( {
            ...provided,
            'color': '#011E4D',
            'backgroundColor': state.selectProps.value.value === state.value ? 'rgb(235, 240, 244)' : 'transparent',
            'fontFamily': 'Graphik-Regular',
            'position': 'relative',
            'padding': '4px 24px 4px',
            'fontSize': '12px',
            'lineHeight': '19px',
            '&:hover': {
                backgroundColor: 'rgb(235, 240, 244)',
                textDecoration: state.isDisabled ? 'none' : 'underline',
            },
            '&:after': {
                content: '""',
                width: '15px',
                height: '15px',
                display: state.isSelected ? 'inline-block' : 'none',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                margin: '0',
                position: 'absolute',
                right: '10px',
                bottom: '30%',
                backgroundImage: state.selectProps.isMulti ? 'url(/assets/images/svg/icon-utility/x.svg)' : 'none',
            },
        } ),
        control: ( styles, state ) => {

            return {
                ...styles,
                'backgroundColor': state.isDisabled ? '#eee' : '#fff',
                'borderWidth': '1px',
                'borderStyle': 'solid',
                'borderColor': state.menuIsOpen ? '#0CAAED' : '#929FB3',
                'borderRadius': '6px',
                'fontFamily': 'Graphik-Regular',
                'fontSize': '16px',
                'color': '#949596',
                'width': filterWidth,
                'maxWidth': '',
                'minHeight': filterHeight,
                'marginRight': 10,
                '&:hover': {
                    borderColor: '#324de6',
                },
            };

        },
        singleValue: ( provided, state ) => {

            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition, color: '#011e4d' };

        },
        placeholder: ( styles, state ) => {

            return {
                ...styles,
                fontFamily: 'Graphik-Regular',
                color: state.isDisabled ? '#949596' : '#949596',
            };

        },
        indicatorsContainer: ( styles ) => {

            return {
                ...styles,
                padding: '5px 0 0',
                alignItems: 'flex-start',
            };

        },
        clearIndicator: ( styles, state ) => {

            if ( state.selectProps.isMulti ) {

                return {
                    ...styles,
                    display: 'none',
                };

            }

            return {
                ...styles,
            };

        },
        indicatorSeparator: ( styles ) => {

            return {
                ...styles,
                width: 0,
            };

        },
        dropdownIndicator: ( styles, state ) => {

            return {
                ...styles,
                color: '#001156',
                transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            };

        },
        menuList: ( styles, state ) => ( {
            ...styles,
            width: '100%',
        } ),
        menu: ( styles, state ) => {

            return {
                ...styles,
                'top': '115%',
                'boxShadow': '0px 4px 6px 0px rgba(0, 0, 0, 0.15)',
                'display': 'flex',
                'backgroundColor': '#fff',
                'border': '1px solid #C9D5DE',
                'borderRadius': '6px',
                'fontFamily': 'Graphik-Regular',
                'fontSize': '14px',
                'lineHeight': '19px',
                'color': '#001d4e',
                'width': isNaN( filterWidth ) ? filterWidth : filterWidth + 16,
                'margin': 0,
                'maxHeight': vp === 'small' || vp === 'medium' ? 450 : 'unset',
                'overflow': 'hidden',
                ' > div': {
                    maxHeight: 'none',
                },
                'zIndex': 999,
            };

        },
    };

};
